import React from "react";
import { useEffect } from "react";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import styles from "../styles/styles";

const ContactUsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header />
      <div className={`${styles.container} my-8 px-4 sm:px-6 lg:px-8`}>
        <h1 className="text-3xl sm:text-4xl font-bold mb-6 text-center text-gray-800">Contact Us</h1>
        
        {/* Contact Information Section */}
        <div className="bg-white shadow-md rounded-lg p-6 max-w-lg mx-auto">
          <div className="mb-4">
            <p className="text-lg font-semibold text-gray-700">
              <strong>Address:</strong> 
            </p>
            <p className="text-gray-600">
              95, Shree Balaji Nagar, Rakkipalayam (post),
              NSN Palayam, Coimbatore - 641 031. 
            </p>
          </div>

          <div className="mb-4">
            <p className="text-lg font-semibold text-gray-700">
              <strong>Phone:</strong> 
            </p>
            <p className="text-gray-600">
              +91 8072368475
            </p>
          </div>

          <div>
            <p className="text-lg font-semibold text-gray-700">
              <strong>Email:</strong>
            </p>
            <p>
              <a
                href="hawler.dev@gmail.com"
                className="text-blue-600 hover:text-blue-800 transition duration-300"
              >
                sales@hawler.co.in
              </a>
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ContactUsPage;

